import React from "react";
import { Modal, Box } from "@mui/material";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 2,
  borderRadius: 2,
  outline: 'none',
  maxWidth: 600,
  maxHeight: '80vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export default function ImageModal({ open, onClose, src, alt }) {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="image-modal" aria-describedby="image-modal-description">
      <Box sx={style}>
        <img
          src={src}
          alt={alt}
          style={{
            maxWidth: '100%',
            maxHeight: '70vh',
            borderRadius: 8,
            boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
          }}
        />
      </Box>
    </Modal>
  );
}
